import BaseRepository from "@/baseRepository/BaseRepository";
const resource = `/api/v1/wallettransactions`;
export default {
    getAllWalletTransactions(baseURL, headers = {}, params = {}) {
        return BaseRepository.get(`${resource}`, {
        baseURL,
        headers,
        params,
      });
    },
    getWalletTransactionsCredit(baseURL, headers = {}, params = {}) {
        return BaseRepository.get(`${resource}/credit/byuser`, {
        baseURL,
        headers,
        params,
      });
    },
    postWalletTransactionsCreditCharge(body, baseURL, headers = {}, params = {}) {
        return BaseRepository.post(`${resource}/charge`, body, {
        baseURL,
        headers,
        params,
      });
  },
     chargeWallByConsumerOwnerUser(body, baseURL,  headers = {}, params = {}) {
        return BaseRepository.post(`${resource}/charge-by-user`,body, {
        baseURL,
        headers,
        params,
        });
     
  }
  }
  